import React, { useMemo } from 'react'
import { keys, map, sortBy } from 'lodash'

import { mergeArrayOfObjects } from '../../../core/utils'

import { StyledAiHighlightedText } from '../../../common/components/styled'
import { AI_HIGHLIGHT_STYLES } from '../../../common/constants'
import { showCommaAtIndex } from '../../../common/utils'

import { DISH_FIELDS_CONFIG } from '../../constants'
import { ingredientsGroupedByFieldNamePropType } from '../../prop-types'
import {
  transformAdditionalIngredientForDisplay,
  transformMainOrChoiceIngredientForDisplay,
} from '../../transformers'

const DishReadOnlyIngredientsCell = ({ ingredientsGroupedByFieldName }) => {
  const sortedIngredients = useMemo(
    () =>
      mergeArrayOfObjects(
        map(keys(ingredientsGroupedByFieldName), fieldName => ({
          [fieldName]: sortBy(
            map(ingredientsGroupedByFieldName[fieldName], ingredient =>
              fieldName === DISH_FIELDS_CONFIG.ADDITIONAL_INGREDIENTS.value
                ? transformAdditionalIngredientForDisplay(ingredient)
                : transformMainOrChoiceIngredientForDisplay(ingredient),
            ),
            'priority',
          ),
        })),
      ),
    [ingredientsGroupedByFieldName],
  )

  return map(keys(sortedIngredients), fieldName => (
    <div key={fieldName}>
      {map(
        sortedIngredients[fieldName],
        (
          {
            ingredient,
            highlight,
            isDiscrepancyAccepted,
            isSuggestedUsingMl,
            isSuggestedUsingParser,
          },
          index,
        ) => (
          <span key={ingredient?.id}>
            <StyledAiHighlightedText
              highlights={[
                highlight,
                ...((isSuggestedUsingMl || isSuggestedUsingParser) &&
                !isDiscrepancyAccepted
                  ? [AI_HIGHLIGHT_STYLES.discrepancyNotAccepted.value]
                  : []),
                ...(!ingredient?.isCurationEnabled
                  ? [AI_HIGHLIGHT_STYLES.curationDisabled.value]
                  : []),
              ]}
            >
              {ingredient.name}
            </StyledAiHighlightedText>
            {showCommaAtIndex(sortedIngredients[fieldName], index)}
          </span>
        ),
      )}
    </div>
  ))
}

DishReadOnlyIngredientsCell.propTypes = {
  ingredientsGroupedByFieldName:
    ingredientsGroupedByFieldNamePropType.isRequired,
}

export default DishReadOnlyIngredientsCell
